
import ahoy from "ahoy.js";

$(document).on('turbolinks:load', function () {
    function force_theme(diseasestateabrv) {
        $('.themed').removeClass('psych').removeClass('neuro').removeClass('respi');
        $('.themed').addClass(diseasestateabrv);
      }

    $(".resource-list-item").on('click', function () {

        $(".resource-popup-content").empty();

        var asset = JSON.parse(decodeURIComponent($(this).data('asset')));
        var file = $(this).data('file');
        var vidurls = $(this).data('videourls')
        var resourcepage = $(this).data('resourcepage')
        var nub_url = $(this).data('nub')

        console.log(vidurls)
        $(".header-text").html(asset.title)
        ahoy.track("asset_view", { title: asset.title, type: asset.resource_type, category: resourcepage + " Resources"});

        console.log(asset);
        switch (asset.resource_type) {
            case 'pdf':
                $(".pdf-pop").show();
                $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent(file) +'#page=' +  $(this).attr('file') + '" width="100%" height="600px" />')
                break;
            case 'video':
                    $(".video-page-pop").show();
                $(".video-page-popup .video-page-content").html('<div class="video-page-button-container">\
                    <div class= " video-page-title" > '+asset.title+'</div >'+nub_url+'\
                    </div >\
                        <div class="video-container">\
                            <video controls src = "' + vidurls[0].video + '" width = "80%" height = "auto" id="video_player" ></video > \
                        </div>')
                    if (vidurls.length <= 1) {
                      $(".video-page-button-container").hide();
                    }
                    for (i = 0; i < vidurls.length; i++) {

                        $(".video-page-button-container").append('<button class=" video-page-buttons" data-video='+vidurls[i].video+ '>'+vidurls[i].title+'</button>')

                    }
                    var diseasestate =   read_cookie("tparea");
                    console.log(diseasestate)
                        if (diseasestate) {
                            $('.video-page-buttons').removeClass('psych');
                            $('.video-page-buttons').removeClass('respi');
                            $('.video-page-buttons').removeClass('neuro');
                      }
                        if (diseasestate == "psychiatry") {
                            $('.themed').addClass('psych')

                        } else if (diseasestate == "respiratory") {
                                $('.themed').addClass('respi')

                        } else {
                            $('.themed').addClass('neuro')

                        }

                break;
            case 'link-list':
                $(".resource-pop .popup-content").empty();
                $(".resource-pop").show();

                for (var i = 0; i < asset.link_resources.length; i++){

                    console.log(asset.link_resources)
                    $(".resource-pop .popup-content").append(
                        '<div class="popup-item"> \
                        <div class="">\
                          <div class="popup-reg-title">'+asset.link_resources[i].title+'</div>\
                          <div class="popup-reg-info">'+ (asset.link_resources[i].tagline || "") + '<span>' + (asset.link_resources[i].link || "") +'</span></div> \
                          <a style="text-decoration: none; font-weight: bold" class="leaving-link" infolink='+asset.link_resources[i].link_ref+ ' description='+ asset.description +'>'+asset.link_resources[i].link_ref+ '</a>\
                        </div> \
                        <div  ' +
                         (asset.link_resources[i].link_type == "pdf" ? ' class="pdf-link" pdf= '+ (asset.link_resources[i].link_ref) : 'class="leaving-link" infolink='+asset.link_resources[i].link_ref+ ' description="Sunovion makes no representation as to the accuracy or any other aspect of the information contained in or on the non-Sunovion sites, sources or servers, nor does Sunovion necessarily endorse such sites or sources."') +'>\
                        <div class="resources-button resources-gradient">\
                          View'+ $(this).data('arrow') +
                        '</div> </div>\
                      </div>'
                    )
                }

                break;
                case 'dropdown-list':
                    $(".resource-pop .popup-content").empty();
                    $(".resource-pop").show();
                for (var i = 0; i < asset.dropdowns.length; i++) {

                    $(".resource-pop .popup-content").append(
                        '<div class="popup-item dropdown-item" dropdown-id='+asset.dropdowns[i].id+'> \
                                <div class="">\
                                    <div class="popup-reg-title" style=" color: black;"><strong>'+ asset.dropdowns[i].title + '</strong></div>\
                                </div> \
                                <img src="assets/conference-arrow.svg" class="dropdown-arrow" style="float: right; filter: invert(0%) saturate(0%) hue-rotate(240deg) brightness(0%) contrast(0%);" />\
                            </div>\
                            <div class="dropdown-list-'+asset.dropdowns[i].id+'" style="display: none;"> \
                            </div>'

                    )
                    var links = asset.dropdowns[i].link_resources
                    for (var k = 0; k < links.length; k++) {
                        $('.dropdown-list-'+asset.dropdowns[i].id).append(
                            '<div class="popup-item"> \
                            <div class="">\
                              <div class="dropdown-popup-reg-title popup-reg-title">'+links[k].title+'</div>\
                              <div class="dropdown-popup-reg-info popup-reg-info">'+ (links[k].tagline || "") + '<span>' + (links[k].link || "") +'</span></div> \
                              <a style="text-decoration: none; font-weight: bold" class="dropdown-leaving-link leaving-link" infolink='+links[k].link_ref+ ' description='+ asset.description +'>'+links[k].link_ref+ '</a>\
                            </div> \
                            <div  ' +
                             (links[k].link_type == "pdf" ? ' class="pdf-link" pdf= '+ (links[k].link_ref) : 'class="leaving-link" infolink='+links[k].link_ref+ ' description="Sunovion makes no representation as to the accuracy or any other aspect of the information contained in or on the non-Sunovion sites, sources or servers, nor does Sunovion necessarily endorse such sites or sources."') +'>\
                            <div class="resources-button resources-gradient">\
                              View'+ $(this).data('arrow') +
                            '</div> </div>\
                          </div>'
                        )
                    }

                }
                    break;
            case 'tooltip-list':
                $(".resource-pop .popup-content").empty();
                $(".resource-pop").show();

                for (var i = 0; i < asset.link_resources.length; i++){
                    console.log(asset.link_resources)

                    $(".resource-pop .popup-content").append(
                        '<div class="popup-item"><div class="popup-item-name">'+asset.link_resources[i].title +'<div class="role-info"> \
                        '+ (asset.link_resources[i].tagline != "" ? '<i class="fas fa-info-circle"></i>': '') + ' \
                            <span class="tooltiptext">'+asset.link_resources[i].tagline+'</span></div></div>\
                            <div  ' +
                            (asset.link_resources[i].link_type == "download" ? ' class="pdf-link" pdf= '+ (asset.link_resources[i].link_ref) : 'class="leaving-link" infolink='+asset.link_resources[i].link_ref + ' description="You are now leaving SunovionMedical.com"') +'>\
                           <div class="resources-button resources-gradient">\
                             View'+ $(this).data('arrow') +
                           '</div> </div>\
                      </div>'
                    )
                }
                break;
            case 'link':
                 $('.link-popup-container').show()
                var infolink = (asset.link);
                var bottom = (asset.description);

                // $('.link-popup-container').show()


                $('.popup-link').attr('href', infolink)
                break;
            case 'sunovion-link':
                    // $('.link-popup-container').show()
                    var infolink = (asset.link);
                    var bottom = (asset.description);

                    // $('.link-popup-container').show()
                    window.open(infolink, '_blank');


                    $('.popup-link').attr('href', infolink)
                    break;
            case 'file':
                $(".resource-pop").show();

                $(".resource-pop .popup-content").html(
                    '<div class="bottom-text">'+asset.description+'</div> \
                    <a href="'+ file +'" download><div class="reg-button gray-gradient" style="margin-bottom: 5px;">ok</div></a>'
                )
                break;
            case 'internal-link':
              window.location.href = asset.link;
                break;

            case 'grants':
                $(".grant-pop").show();
            break;
        }
        if ($(this).data("diseasestate").length > 1) {
            force_theme($(this).data("diseasestate"));
          }
    });
    $(".modal-close").on('click', function () {
        $(".resource-pop").hide();
        $('#video_player')[0].pause()
        console.log("TESTSTS")

    })
    if(window.location.hash.startsWith("#asset=")) {
      var id =window.location.hash.substr(7);
      $("#asset-target-" + id).click();
      console.log("tried to click")
    } else {

    }


    $('body').on('click', '.pdf-link', function () {
        console.log($(this).attr('pdf'));

        $(".pdf-pop").show();

        $(".pdf-pop .popup-content").html('<iframe src="/pdfviewer?file='+ encodeURIComponent($(this).attr('pdf')) +'#page=' +  $(this).attr('page') + '" width="100%" height="600px" />')
    })
    $('body').on('click', '.dropdown-item', function () {
        console.log($(this).attr('dropdown-id'))
        var id = $(this).attr('dropdown-id');
        if ($('.dropdown-list-' + id).is(":hidden")) {
            $('.dropdown-list-' + id).show();
            $(this).addClass('dropdown-active');
        } else {
            $('.dropdown-list-' + id).hide();
            $(this).removeClass('dropdown-active');

        }
    })
    $('body').on('click', '.video-buttons', function () {
        var video = $(this).data('video')
        $('.video-content video').attr('src', video);
    })

    $('body').on('click', '.video-page-buttons', function () {
        var video = $(this).data('video')
        $('.video-content video').attr('autoplay', true);
        document.getElementById("video_player").setAttribute('autoplay', true);

        $('.video-page-content video').attr('src', video);
        $('.video-page-buttons').removeClass('selected');

        $(this).addClass('selected');
    })


    $('body').on('click', '.leaving-link', function () {

        var infolink = $(this).attr("infolink");
        var bottom = $(this).attr("description");
        // window.open(infolink, '_blank');

        // $('.link-popup-container').show()
        $('.bottom-text').html(" ")

        $('.popup-link').attr('href', infolink)
    })

})
